<template>
  <!-- Content Wrapper. Contains page content -->
  <div id="content-wrap" class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Dashboard
        <small>Version 2.0</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Dashboard</li>
      </ol>
    </section>

    <section class="content">
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>

<script>
import VAInfoBox from 'va/widgets/VAInfoBox.vue'
import VABox from 'va/widgets/VABox.vue'
import SoftPhone from '../components/telephone/SoftPhone'
import {mapActions} from 'vuex'

export default {
  name: 'Dashboard',
  components: {
    'va-info-box': VAInfoBox,
    'va-box': VABox,
    SoftPhone
  },
  methods: {
    ...mapActions([
      'changePhoneNumber'
    ]),
    callPhone () {
      this.changePhoneNumber({phoneNumber: '0386714792'})
      this.$bvModal.show('phone-call-modal')
    }
  }
}
</script>

<style scoped>
.page-enter-active, .page-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.page-enter, .page-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue